module.exports = __webpack_public_path__ + "2acf16bde0276e78dff5fadab71052fd.svg";